import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const CollapseIcon = ({ width = 24, height = 24, color = colors.grey[50] }: IProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24' fill='none'>
            <path
                d='M11.9872 7.09152C11.775 7.09471 11.5723 7.18088 11.4223 7.33089L3.25163 15.5016C3.03779 15.7058 2.95161 16.0107 3.02662 16.2979C3.10162 16.5836 3.32504 16.807 3.61069 16.882C3.89794 16.957 4.20275 16.8708 4.40701 16.657L12 9.06397L19.593 16.657C19.7973 16.8708 20.1021 16.957 20.3893 16.882C20.675 16.807 20.8984 16.5836 20.9734 16.2979C21.0484 16.0107 20.9622 15.7058 20.7484 15.5016L12.5777 7.33089C12.4213 7.1745 12.2091 7.08832 11.9872 7.09152Z'
                fill={color}
            />
        </svg>
    )
}

export default React.memo(CollapseIcon)
